import { DynamicFormInputComponent } from "../dynamic-form-input/dynamic-form-input.component";
import { BetweenDateComponent } from "../between-date/between-date.component";
import { DynamicControl } from "../interfaces/DynamicControl";
import { Fields } from "./dynamic-form-config";
import { Type } from "@angular/core";
import { AutoCompleteServidorComponent } from "../auto-complete-servidor/auto-complete-servidor.component";
import { DynamicFormInputAnoComponent } from "../dynamic-form-input-ano/dynamic-form-input-ano.component";
import { DateComponent } from "../date/date.component";

type ComponentFields = {
  [Property in Fields]: Type<DynamicControl>;
};

export const components: ComponentFields = {
  input: DynamicFormInputComponent,
  inputAno: DynamicFormInputAnoComponent,
  betweenDate: BetweenDateComponent,
  autoCompleteServidor: AutoCompleteServidorComponent,
  date: DateComponent,
};
